import { BarcodeTypeEnum, OperationCategoryEnum, PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('t_tracking_info')
export class TrackingInfoEntity extends CommonFieldsModel{
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: string;
   
    @Column('mediumint', {
        nullable: false,
        name: 'po_header_id'
    })
    poHeaderId: number;

    @Column('mediumint', {
        nullable: false,
        name: 'po_schedule_id'
    })
    poScheduleId: number;

    @Column('varchar', {
        nullable: false,
        length: 15,
        name: 'schedule'
    })
    schedule: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'style'
    })
    style: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'color'
    })
    color: string;
    
    @Column('smallint', {
        nullable: false,
        name: 'year'
    })
    year: number;

    @Column('tinyint', {
        nullable: false,
        name: 'month'
    })
    month: number;

    @Column('tinyint', {
        nullable: false,
        name: 'hour'
    })
    hour: number;

    @Column('tinyint', {
        nullable: false,
        name: 'minute'
    })
    minute: number;

    @Column('mediumint', {
        nullable: false,
        default: 0,
        name: 'good_quantity'
    })
    goodQuantity: number;

    @Column('mediumint', {
        nullable: false,
        default: 0,
        name: 'rework_quantity'
    })
    reworkQuantity: number;

    @Column('mediumint', {
        nullable: false,
        default: 0,
        name: 'rejected_quantity'
    })
    rejectedQuantity: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'date'
    })
    date: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'ref_type'
    })
    refType: BarcodeTypeEnum;

    @Column('varchar', {
        nullable: true,
        default: '0',
        length: 30,
        name: 'ref_id'
    })
    refId: string;
    
    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'line',
        default: '',
    })
    line: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'workstation',
        default: '',
    })
    workstation: string;

    @Column('varchar', {
        nullable: false,
        length: 6,
        name: 'op_code'
    })
    opCode: string;

    @Column('varchar', {
        nullable: false,
        length: 1,
        name: 'op_category'
    })
    opCategory: OperationCategoryEnum;    

    @Column('tinyint', {
        nullable: false,
        name: 'op_sequence'
    })
    opSequence: number;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'timestamp'
    })
    timestamp: number;
}

